/**
 * @generated SignedSource<<b23eafaa8e5c648411d3982fdbd7c3c6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MaxDistanceSliderInput_query$data = {
  readonly currentUser: {
    readonly isMetricSystem: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "MaxDistanceSliderInput_query";
};
export type MaxDistanceSliderInput_query$key = {
  readonly " $data"?: MaxDistanceSliderInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"MaxDistanceSliderInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MaxDistanceSliderInput_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMetricSystem",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d84df4477afccafbe374ac0c88aa3f2f";

export default node;
